import script from "./FactorTemp.vue?vue&type=script&setup=true&lang=js"
export * from "./FactorTemp.vue?vue&type=script&setup=true&lang=js"

import "./FactorTemp.vue?vue&type=style&index=0&id=6fb0fe30&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fb0fe30"]])

export default __exports__